import { autoinject } from "aurelia-framework";

/**
 * Custom element that provides a grid layout for its child elements.
 */
@autoinject
export class GridLayoutCustomElement
{
}
